import React, {useEffect} from "react";
import {useSearchParams, useNavigate} from "react-router-dom";
import useVerifyAccount from "../hooks/useVerifyLink";
import {useAppContext} from "../context/AppContext";
import Spinner from "../components/Spinner";

const VerifyPage = () => {
  const {setToken, token} = useAppContext();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const email = searchParams.get("email");
  const pin = searchParams.get("pin");

  const {verifyData, isLoading, isError, error} = useVerifyAccount(email, pin);
  useEffect(() => {
    if (token) {
      navigate("/");
      return;
    }
    if (verifyData === null && !isLoading) {
      navigate("/");
    }
  }, [token, verifyData, isLoading, navigate]);

  useEffect(() => {
    if (verifyData?.success) {
      const token = verifyData?.data?.token;
      if (token) {
        setToken(token);
        localStorage.setItem("iris-accessToken", token);
      }
      const timer = setTimeout(() => navigate("/"), 10000);
      return () => clearTimeout(timer);
    }
  }, [verifyData, navigate, setToken]);

  return (
    <div className="overlay-login login-modal-container">
      <div className="card">
        {isLoading ? (
          <Spinner variant="medium-spinner" alignSpin="center-spinner" />
        ) : (
          <React.Fragment>
            <h2 className="title">Welcome to iRis!</h2>
            <p style={{lineHeight: 1.4, marginTop: 5}}>
              {isError && `❌ ${error?.message || "Verification failed."}`}
              {verifyData?.success &&
                "Your account has been successfully activated! Redirecting shortly..."}
            </p>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
